module.exports = __webpack_public_path__ + "static/media/susd.29f71b43.svg";